<div class="flex flex-col h-full p-4 pt-0">
    <div class="text-xl font-semibold">Total Due vs Total Paid</div>

    <!-- Loading Skeleton -->
    <div *ngIf="isLoading()" class="chart-container h-[40rem] flex items-center justify-center">
        <div class="flex flex-col items-center gap-3">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <p class="text-gray-500 text-sm">Loading chart...</p>
        </div>
    </div>
    
           <!-- Chart Content -->
       <div *ngIf="!isLoading()" class="chart-container h-[40rem]">
            <canvas baseChart
                [data]="chartData()"
                [options]="chartOptions"
                type="line">
            </canvas>
        </div> 
</div>